export const a3employeeoptions = [
    {
        text: '北京大区',
        value: '北京大区',
        children: [
            { text: '[2798]段旭瑞', value: '[2798]段旭瑞' },
            { text: '[2819]邓修军', value: '[2819]邓修军' },
            { text: '[1025]张康', value: '[1025]张康' },
            { text: '[2792]罗敏敏', value: '[2792]罗敏敏' },
            { text: '[2812]崔盛楠', value: '[2812]崔盛楠' },
            { text: '[10230]王海燕', value: '[10230]王海燕' },
            { text: '[2221]丁晓琳', value: '[2221]丁晓琳' },
            { text: '[2663]曹娣', value: '[2663]曹娣' },
            { text: '[2769]邓利利', value: '[2769]邓利利' },
            { text: '[2231]崔艳南', value: '[2231]崔艳南' },
            { text: '[25013]房艳广', value: '[25013]房艳广' },
            { text: '[31000]杨玉蒙', value: '[31000]杨玉蒙' },
            { text: '[3315]黄计春', value: '[3315]黄计春' },
            { text: '[3528]陈静', value: '[3528]陈静' },
            { text: '[31001]张雪晴', value: '[31001]张雪晴' },
            { text: '[2331]王晓霞', value: '[2331]王晓霞' },
            { text: '[2764]王天婷', value: '[2764]王天婷' },
            { text: '[2300]谢曼莉', value: '[2300]谢曼莉' },
            { text: '[31015]霍宗立', value: '[31015]霍宗立' },
            { text: '[31006]陈云鹏', value: '[31006]陈云鹏' },
            { text: '[31012]吉小卫', value: '[31012]吉小卫' },
            { text: '[3515]王巧玲', value: '[3515]王巧玲' },
            { text: '[31017]李超', value: '[31017]李超' },
            { text: '[1406]刘红', value: '[1406]刘红' }
        ]
    },
    {
        text: '常州体验店',
        value: '常州体验店',
        children: [
            { text: '[1369]王雷', value: '[1369]王雷' },
            { text: '[32578]陈云', value: '[32578]陈云' },
            { text: '[1367]张利斌', value: '[1367]张利斌' },
            { text: '[32607]徐雪华', value: '[32607]徐雪华' },
            { text: '[32593]史俊雪', value: '[32593]史俊雪' }
        ]
    },
    {
        text: '创新体验中心',
        value: '创新体验中心',
        children: [
            { text: '[36005]王前倩', value: '[36005]王前倩' },
            { text: '[36001]闫云霞', value: '[36001]闫云霞' },
            { text: '[36007]王致芬', value: '[36007]王致芬' },
            { text: '[36009]李鹏辉', value: '[36009]李鹏辉' },
            { text: '[36008]杨贝贝', value: '[36008]杨贝贝' },
            { text: '[36020]孙凯', value: '[36020]孙凯' },
            { text: '[36030]汤龙雨', value: '[36030]汤龙雨' },
            { text: '[36000]王云天', value: '[36000]王云天' },
            { text: '[36024]余贵安', value: '[36024]余贵安' },
            { text: '[36002]张鑫', value: '[36002]张鑫' }
        ]
    },
    {
        text: '广东省区',
        value: '广东省区',
        children: [
            { text: '[3545]黄永生', value: '[3545]黄永生' },
            { text: '[2795]刘丽敏', value: '[2795]刘丽敏' },
            { text: '[2790]严少荣', value: '[2790]严少荣' },
            { text: '[2781]王朕', value: '[2781]王朕' },
            { text: '[2796]张楠', value: '[2796]张楠' },
            { text: '[21098]张佩', value: '[21098]张佩' },
            { text: '[2788]杨国庆', value: '[2788]杨国庆' },
            { text: '[2920]王建', value: '[2920]王建' },
            { text: '[21175]张梓梦', value: '[21175]张梓梦' },
            { text: '[21221]王鑫磊', value: '[21221]王鑫磊' },
            { text: '[21088]张保华', value: '[21088]张保华' },
            { text: '[32034]荣誉', value: '[32034]荣誉' },
            { text: '[32047]张磊', value: '[32047]张磊' },
            { text: '[32027]赖海燕', value: '[32027]赖海燕' },
            { text: '[32059]韩晓农', value: '[32059]韩晓农' },
            { text: '[32035]王小催', value: '[32035]王小催' },
            { text: '[32020]余敏', value: '[32020]余敏' },
            { text: '[32078]张艺川', value: '[32078]张艺川' },
            { text: '[32071]成永康', value: '[32071]成永康' },
            { text: '[1409]赵浴时', value: '[1409]赵浴时' },
            { text: '[32000]田颖', value: '[32000]田颖' }
        ]
    },
    {
        text: '湖北省区',
        value: '湖北省区',
        children: [
            { text: '[10208]邓玉梅组长', value: '[10208]邓玉梅组长' },
            { text: '[10549]周玮组长', value: '[10549]周玮组长' },
            { text: '[10157]孙正才组长', value: '[10157]孙正才组长' },
            { text: '[10754]罗娇', value: '[10754]罗娇' },
            { text: '[10526]邹月玲', value: '[10526]邹月玲' },
            { text: '[10153]乐芳芳', value: '[10153]乐芳芳' },
            { text: '[33019]刘雷雷', value: '[33019]刘雷雷' },
            { text: '[10173]李小琴', value: '[10173]李小琴' },
            { text: '[10601]聂小雨', value: '[10601]聂小雨' },
            { text: '[10684]包红艳', value: '[10684]包红艳' },
            { text: '[10196]蔡晓航', value: '[10196]蔡晓航' },
            { text: '[10183]江慧', value: '[10183]江慧' },
            { text: '[10623]谢群瑶', value: '[10623]谢群瑶' },
            { text: '[10735]黄红宾', value: '[10735]黄红宾' },
            { text: '[10108]梁丝', value: '[10108]梁丝' },
            { text: '[33014]石坤', value: '[33014]石坤' },
            { text: '[10249]徐鹏', value: '[10249]徐鹏' },
            { text: '[2767]刘伟', value: '[2767]刘伟' },
            { text: '[33025]吕洋', value: '[33025]吕洋' },
            { text: '[33517]杜明珠', value: '[33517]杜明珠' },
            { text: '[33028]曹凯鹏', value: '[33028]曹凯鹏' }
        ]
    },
    {
        text: '会员三区',
        value: '会员三区',
        children: [
            { text: '[2783]闫萌萌组长', value: '[2783]闫萌萌组长' },
            { text: '[23050]张小刚', value: '[23050]张小刚' },
            { text: '[25113]彭海', value: '[25113]彭海' },
            { text: '[10219]李春花', value: '[10219]李春花' },
            { text: '[1500]任存营组长', value: '[1500]任存营组长' },
            { text: '[4610]郭红艳', value: '[4610]郭红艳' },
            { text: '[5003]张力辉', value: '[5003]张力辉' },
            { text: '[2321]姚良生组长', value: '[2321]姚良生组长' },
            { text: '[2493]王珍', value: '[2493]王珍' },
            { text: '[22006]陈欣华', value: '[22006]陈欣华' },
            { text: '[2701]王晓杰', value: '[2701]王晓杰' },
            { text: '[2463]柯玉琴', value: '[2463]柯玉琴' },
            { text: '[2353]陈武君', value: '[2353]陈武君' },
            { text: '[2335]蔡晶晶', value: '[2335]蔡晶晶' },
            { text: '[1526]王鑫', value: '[1526]王鑫' },
            { text: '[2349]张建', value: '[2349]张建' },
            { text: '[2305]郝海川', value: '[2305]郝海川' },
            { text: '[1390]徐宝龙', value: '[1390]徐宝龙' },
            { text: '[6013]杜科锦', value: '[6013]杜科锦' },
            { text: '[34032]李登攀', value: '[34032]李登攀' },
            { text: '[25201]何静静', value: '[25201]何静静' },
            { text: '[2657]韩莎莎', value: '[2657]韩莎莎' },
            { text: '[2751]秦爱兰', value: '[2751]秦爱兰' }
        ]
    },
    {
        text: '会员一区',
        value: '会员一区',
        children: [
            { text: '[21064]吴凤婷', value: '[21064]吴凤婷' },
            { text: '[4302]吴碧川', value: '[4302]吴碧川' },
            { text: '[2702]和二英', value: '[2702]和二英' },
            { text: '[3622]乔晓磊组长', value: '[3622]乔晓磊组长' },
            { text: '[2932]钱云秋组长', value: '[2932]钱云秋组长' },
            { text: '[2475]张绍庆', value: '[2475]张绍庆' },
            { text: '[2915]王松林组长', value: '[2915]王松林组长' },
            { text: '[21067]白双华', value: '[21067]白双华' },
            { text: '[23110]赵鹏', value: '[23110]赵鹏' },
            { text: '[24131]尹新雷', value: '[24131]尹新雷' },
            { text: '[2396]郭学丽', value: '[2396]郭学丽' },
            { text: '[4207]李艳冰', value: '[4207]李艳冰' },
            { text: '[2439]张丹', value: '[2439]张丹' },
            { text: '[3438]唐建顺', value: '[3438]唐建顺' },
            { text: '[2855]王美如', value: '[2855]王美如' },
            { text: '[2249]孔丹丹', value: '[2249]孔丹丹' },
            { text: '[1363]黄学潮', value: '[1363]黄学潮' },
            { text: '[35508]张改素', value: '[35508]张改素' },
            { text: '[3611]王维', value: '[3611]王维' },
            { text: '[21156]高艳', value: '[21156]高艳' },
            { text: '[22162]郝振岭', value: '[22162]郝振岭' },
            { text: '[10518]罗艳兰', value: '[10518]罗艳兰' },
            { text: '[3642]孙海霞', value: '[3642]孙海霞' },
            { text: '[2818]辛秀芳', value: '[2818]辛秀芳' },
            { text: '[2899]李佳庆', value: '[2899]李佳庆' },
            { text: '[5201]杨兴兴', value: '[5201]杨兴兴' }
        ]
    },
    {
        text: '江苏省区',
        value: '江苏省区',
        children: [
            { text: '[3345]夏婷婷', value: '[3345]夏婷婷' },
            { text: '[2608]刘满', value: '[2608]刘满' },
            { text: '[2846]吕凤伦', value: '[2846]吕凤伦' },
            { text: '[10593]朱玉敏', value: '[10593]朱玉敏' },
            { text: '[10541]王东叶', value: '[10541]王东叶' },
            { text: '[2843]吕长伟', value: '[2843]吕长伟' },
            { text: '[2523]焦杨杰', value: '[2523]焦杨杰' },
            { text: '[2910]胡梦阳', value: '[2910]胡梦阳' },
            { text: '[32509]刘宝玉', value: '[32509]刘宝玉' },
            { text: '[2753]张树恒', value: '[2753]张树恒' },
            { text: '[22088]张武林', value: '[22088]张武林' },
            { text: '[3552]王金龙', value: '[3552]王金龙' },
            { text: '[2771]罗华杰', value: '[2771]罗华杰' },
            { text: '[4200]孙梦', value: '[4200]孙梦' },
            { text: '[2686]李丁丁', value: '[2686]李丁丁' },
            { text: '[32549]张明博', value: '[32549]张明博' },
            { text: '[10547]李便保', value: '[10547]李便保' },
            { text: '[32573]贠永刚', value: '[32573]贠永刚' },
            { text: '[22047]朱委委', value: '[22047]朱委委' },
            { text: '[2707]李帅', value: '[2707]李帅' },
            { text: '[6004]陈振国', value: '[6004]陈振国' },
            { text: '[32609]黎杰', value: '[32609]黎杰' },
            { text: '[32585]张冬梅', value: '[32585]张冬梅' },
            { text: '[32592]蒋昌艳', value: '[32592]蒋昌艳' }
        ]
    },
    {
        text: '媒体会服',
        value: '媒体会服',
        children: [
            { text: '[3401]王道驰', value: '[3401]王道驰' },
            { text: '[2830]孙福来', value: '[2830]孙福来' },
            { text: '[35009]赵鑫', value: '[35009]赵鑫' },
            { text: '[4220]张黎', value: '[4220]张黎' },
            { text: '[1700]龙登云', value: '[1700]龙登云' },
            { text: '[3550]谢宏伟', value: '[3550]谢宏伟' },
            { text: '[6675]王晓斌', value: '[6675]王晓斌' },
            { text: '[14029]马志广', value: '[14029]马志广' },
            { text: '[1742]李树云', value: '[1742]李树云' },
            { text: '[4204]续宇慧', value: '[4204]续宇慧' },
            { text: '[1416]侯凤侠', value: '[1416]侯凤侠' },
            { text: '[1386]张艳艳', value: '[1386]张艳艳' },
            { text: '[3742]侯玉珠', value: '[3742]侯玉珠' },
            { text: '[2545]丁向莉', value: '[2545]丁向莉' },
            { text: '[34050]赵莹', value: '[34050]赵莹' },
            { text: '[2514]沈艳丽', value: '[2514]沈艳丽' },
            { text: '[35520]张清连', value: '[35520]张清连' }
        ]
    },
    {
        text: '山东省区',
        value: '山东省区',
        children: [
            { text: '[2842]耿兵', value: '[2842]耿兵' },
            { text: '[3530]沈钦贵', value: '[3530]沈钦贵' },
            { text: '[3567]李镔', value: '[3567]李镔' },
            { text: '[2856]王朋峰', value: '[2856]王朋峰' },
            { text: '[1038]姬长远', value: '[1038]姬长远' },
            { text: '[3670]杜海洋', value: '[3670]杜海洋' },
            { text: '[24033]李向飞', value: '[24033]李向飞' },
            { text: '[34500]白晓菊', value: '[34500]白晓菊' },
            { text: '[36500]赵永富', value: '[36500]赵永富' }
        ]
    },
    {
        text: '上海大区',
        value: '上海大区',
        children: [
            { text: '[2791]徐秀梅', value: '[2791]徐秀梅' },
            { text: '[1314]赵钱娣', value: '[1314]赵钱娣' },
            { text: '[2782]胡振宇', value: '[2782]胡振宇' },
            { text: '[2848]吴迪', value: '[2848]吴迪' },
            { text: '[3549]刘志林', value: '[3549]刘志林' },
            { text: '[2793]秦倩', value: '[2793]秦倩' },
            { text: '[2780]宋春雨', value: '[2780]宋春雨' },
            { text: '[31523]王静', value: '[31523]王静' },
            { text: '[2765]邵丽娜', value: '[2765]邵丽娜' },
            { text: '[31555]周燕平', value: '[31555]周燕平' },
            { text: '[31542]黄甲甲', value: '[31542]黄甲甲' },
            { text: '[10126]刘亚平', value: '[10126]刘亚平' },
            { text: '[31561]徐不凡', value: '[31561]徐不凡' },
            { text: '[31580]刘京哲', value: '[31580]刘京哲' },
            { text: '[2241]李燎原', value: '[2241]李燎原' },
            { text: '[31571]胡鸿俊', value: '[31571]胡鸿俊' },
            { text: '[2880]吕彩云经理', value: '[2880]吕彩云经理' },
            { text: '[31535]葛秀慧', value: '[31535]葛秀慧' }
        ]
    },
    {
        text: '上海体验店',
        value: '上海体验店',
        children: [
            { text: '[31503]刘武警组长', value: '[31503]刘武警组长' }
        ]
    },
    {
        text: '数据运营',
        value: '数据运营',
        children: [
            { text: '[4248]赵莹莹', value: '[4248]赵莹莹' },
            { text: '[1381]郑宝亮', value: '[1381]郑宝亮' },
            { text: '[1545]张建', value: '[1545]张建' },
            { text: '[3678]刘娜组长', value: '[3678]刘娜组长' },
            { text: '[3441]金荣斌组长', value: '[3441]金荣斌组长' },
            { text: '[21140]李艳清', value: '[21140]李艳清' },
            { text: '[35000]牛小华', value: '[35000]牛小华' },
            { text: '[3604]魏冬冬', value: '[3604]魏冬冬' },
            { text: '[3621]武小菊', value: '[3621]武小菊' },
            { text: '[35002]王泰胺', value: '[35002]王泰胺' },
            { text: '[2904]李晓晓', value: '[2904]李晓晓' },
            { text: '[4219]李阳阳', value: '[4219]李阳阳' },
            { text: '[1508]刘丽红', value: '[1508]刘丽红' },
            { text: '[21148]尚智峰', value: '[21148]尚智峰' },
            { text: '[35008]吴凡', value: '[35008]吴凡' }
        ]
    },
    {
        text: '四川省区',
        value: '四川省区',
        children: [
            { text: '[37507]秦倩', value: '[37507]秦倩' },
            { text: '[37510]刘京哲', value: '[37510]刘京哲' },
            { text: '[37508]宋春雨', value: '[37508]宋春雨' },
            { text: '[37511]徐不凡', value: '[37511]徐不凡' },
            { text: '[10109]马家余', value: '[10109]马家余' },
            { text: '[37512]刘亚平', value: '[37512]刘亚平' },
            { text: '[37509]刘志林', value: '[37509]刘志林' },
            { text: '[10546]陈萍', value: '[10546]陈萍' },
            { text: '[37513]胡鸿俊', value: '[37513]胡鸿俊' },
            { text: '[10521]李锐', value: '[10521]李锐' },
            { text: '[10145]占维', value: '[10145]占维' },
            { text: '[10514]唐傲霞', value: '[10514]唐傲霞' }
        ]
    },
    {
        text: '武汉体验店',
        value: '武汉体验店',
        children: [
            { text: '[33017]吴远荣', value: '[33017]吴远荣' },
            { text: '[10845]杨飞', value: '[10845]杨飞' }
        ]
    },
    {
        text: '浙江省区',
        value: '浙江省区',
        children: [
            { text: '[10617]刘欣欣', value: '[10617]刘欣欣' },
            { text: '[10539]陈云', value: '[10539]陈云' },
            { text: '[23092]王致秋', value: '[23092]王致秋' },
            { text: '[4226]翟亚军', value: '[4226]翟亚军' },
            { text: '[2752]郭勇', value: '[2752]郭勇' },
            { text: '[23009]曹金贵', value: '[23009]曹金贵' },
            { text: '[25060]杨前', value: '[25060]杨前' },
            { text: '[37002]马欢', value: '[37002]马欢' },
            { text: '[37010]胡正', value: '[37010]胡正' },
            { text: '[37000]翟现宽', value: '[37000]翟现宽' },
            { text: '[37003]翟现宽', value: '[37003]翟现宽' }
        ]
    }
];    